import { Component, inject, Input, type OnInit } from '@angular/core';
import type { UserUpdate } from '../../../server/types/message-types';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-thread-user-update-display',
  templateUrl: './thread-user-update-display.component.html',
  styleUrls: ['./thread-user-update-display.component.scss'],
  standalone: false,
})
export class ThreadUserUpdateDisplayComponent implements OnInit {
  private authUserService = inject(AuthUserService);

  @Input() orgId: string;
  @Input() update: UserUpdate;

  updaterName = '';
  addedNames: string[] = [];
  removedNames: string[] = [];

  updaterJoined = false;
  updaterLeft = false;

  dateString = '';

  ngOnInit(): void {
    this.updaterName = this.name(this.update.updatedBy);
    const time = new Date(this.update.updatedAt);
    this.dateString =
      time.toTimeString().substring(0, 5) +
      ', ' +
      time.toDateString().substring(4);

    this.update.addUserIds?.forEach((userId) => {
      if (userId === this.update.updatedBy) return (this.updaterJoined = true); // Self-added in task discussion
      this.addedNames.push(this.name(userId));
    });

    this.update.removeUserIds?.forEach((userId) => {
      if (userId === this.update.updatedBy) return (this.updaterLeft = true); // Self removed from discussion
      this.removedNames.push(this.name(userId));
    });
  }

  private name(userId: string) {
    return (
      this.authUserService.getUser({
        orgId: this.orgId,
        userId,
      })?.name ?? 'Unknown user'
    );
  }
}
